import { AiNodeContext } from "@intelligems/ig-types";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@src/store";

interface InitialContextEntry {
  context: AiNodeContext;
  isValid: boolean;
  error?: string;
}

export interface WorkflowInitialContextState {
  contexts: Record<string, InitialContextEntry>;
}

const initialState: WorkflowInitialContextState = {
  contexts: {},
};

const workflowInitialContextSlice = createSlice({
  name: "workflowInitialContext",
  initialState,
  reducers: {
    setInitialContext: (
      _state: any,
      action: PayloadAction<{
        workflowId: string;
        context: AiNodeContext;
        isValid: boolean;
        error?: string;
      }>
    ) => {
      const state = _state as WorkflowInitialContextState;
      const { workflowId, context, isValid, error } = action.payload;
      state.contexts[workflowId] = { context, isValid, error };
    },
    clearInitialContext: (state, action: PayloadAction<string>) => {
      delete state.contexts[action.payload];
    },
  },
  selectors: {
    getInitialContext: (
      state: WorkflowInitialContextState,
      workflowId: string
    ) => state.contexts[workflowId] || { context: "", isValid: true },
    getAllInitialContexts: (state) => state.contexts,
  },
});

export const makeGetInitialContext =
  (workflowId: string) => (state: RootState) => {
    return (
      state.workflowInitialContext.contexts[workflowId] || {
        context: "",
        isValid: true,
      }
    );
  };

export const { setInitialContext, clearInitialContext } =
  workflowInitialContextSlice.actions;

export const workflowInitialContextReducer =
  workflowInitialContextSlice.reducer;
export const { getInitialContext, getAllInitialContexts } =
  workflowInitialContextSlice.selectors;
